export const FETCH_MY_ORDERS_START = 'FETCH_MY_ORDERS_START';
export const FETCH_MY_ORDERS_SUCCESS = 'FETCH_MY_ORDERS_SUCCESS';
export const FETCH_MY_ORDERS_FAILURE = 'FETCH_MY_ORDERS_FAILURE';

export const SET_MY_ORDER_SUCCESS = 'SET_MY_ORDER_SUCCESS';

